import { TFormalOffers } from '@helpers/FormalOffers/formalOffers.types';
import { getFormalOffersMaxAvailableCash } from '@helpers/FormalOffers/getFormalOffersMaxAvailableCash';
import { getIsInterestOnlyOffer } from '@helpers/FormalOffers/getIsInterestOnlyOffer';
import { getIsRBLOffer } from '@helpers/FormalOffers/getIsRBLOffer';
import { getCountry } from '@iwIntlProvider/CountryProvider';

type TGetCustomiseOfferData = {
    maxAvailableCash: number;
    shouldShowOfferTypeSelection: boolean;
    hasInterestOnlyChoice: boolean;
    initialOfferChoices: TFormalOffers;
};

export const useGetCustomiseOfferData = (
    formalOffers: TFormalOffers
): TGetCustomiseOfferData => {
    const maxAvailableCash = getFormalOffersMaxAvailableCash(formalOffers);

    //set default initial Offers when there are only 2 formal offers
    const initialOfferChoices = !getShouldShowOfferTypeSelection(formalOffers)
        ? formalOffers
        : [];

    //needed to indicate the copy that is used in section headings
    const hasInterestOnlyChoice = Boolean(
        formalOffers.find((formal_offer) =>
            getIsInterestOnlyOffer(formal_offer)
        )
    );

    return {
        maxAvailableCash,
        shouldShowOfferTypeSelection:
            getShouldShowOfferTypeSelection(formalOffers),
        hasInterestOnlyChoice,
        initialOfferChoices
    };
};

const getShouldShowOfferTypeSelection = (formalOffers: TFormalOffers) => {
    if (getCountry() === 'UK') {
        return false;
    } else if (formalOffers.length === 1) {
        return false;
    } else if (formalOffers.length === 2) {
        if (formalOffers.find((offer) => getIsRBLOffer(offer))) return true;
        else return false;
    } else {
        return true;
    }
};
